import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { notificationService } from '../services/api';
import { getUserData, isAuthenticated } from '../utils/auth';
import './Notifications.css';

function Notifications() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const userData = getUserData();
  const userId = userData?.userId ?? userData?.UserId ?? userData?.id ?? userData?.Id;

  useEffect(() => {
    if (!isAuthenticated() || !userId) {
      setError('Please log in to view notifications.');
      setLoading(false);
      return;
    }
    notificationService
      .getByUser(userId)
      .then((data) => setList(Array.isArray(data) ? data : []))
      .catch((e) => {
        setError(e.message || 'Failed to load notifications.');
        setList([]);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  const handleMarkRead = async (id) => {
    try {
      await notificationService.markRead(id);
      setList((prev) =>
        prev.map((n) => (n.Id === id ? { ...n, IsRead: true } : n))
      );
    } catch (e) {
      console.error('Mark read failed:', e);
    }
  };

  const formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min ago`;
    if (diffHours < 24) return `${diffHours} hr ago`;
    if (diffDays < 7) return `${diffDays} day(s) ago`;
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const unreadCount = list.filter((n) => !n.IsRead).length;

  if (!isAuthenticated()) {
    return (
      <div className="notifications-page">
        <div className="notifications-container">
          <p>Please <Link to="/login">log in</Link> to view your notifications.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="notifications-page">
      <div className="notifications-container">
        <div className="notifications-header">
          <h1>Notifications</h1>
          {unreadCount > 0 && (
            <span className="notifications-badge">{unreadCount} unread</span>
          )}
        </div>

        {loading ? (
          <div className="notifications-loading">Loading notifications...</div>
        ) : error ? (
          <div className="notifications-error">{error}</div>
        ) : list.length === 0 ? (
          <div className="notifications-empty">
            <p>No notifications yet.</p>
          </div>
        ) : (
          <ul className="notifications-list">
            {list.map((n) => (
              <li
                key={n.Id}
                className={`notification-item ${n.IsRead ? 'read' : 'unread'}`}
              >
                <div className="notification-body">
                  <p className="notification-message">{n.Message}</p>
                  <span className="notification-date">{formatDate(n.CreatedDate)}</span>
                </div>
                {!n.IsRead && (
                  <button
                    type="button"
                    className="notification-mark-read"
                    onClick={() => handleMarkRead(n.Id)}
                  >
                    Mark as read
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Notifications;
